type AudioQueueItem = {
  url: string;
  sid?: string;
  msgId?: string;
};

export class AudioQueuePlayer {
  private audio: HTMLAudioElement;
  private queue: AudioQueueItem[] = [];
  private isPlaying = false;

  constructor() {
    this.audio = new Audio();
    this.audio.crossOrigin = 'anonymous';
    this.audio.addEventListener('ended', this.handleEnded);
  }

  private handleEnded = () => {
    this.isPlaying = false;
    this.playNext();
  };

  /** 添加音频到队列 */
  public add(url: string, sid?: string, msgId?: string) {
    this.queue.push({ url, sid, msgId });

    if (!this.isPlaying) this.playNext();
  }

  /** 播放下一个 */
  private playNext() {
    if (this.queue.length === 0) return;

    const next = this.queue.shift();

    if (!next) return;

    this.audio.src = next.url;
    this.audio.currentTime = 0;
    this.audio.play().catch((err) => console.error('播放失败:', err));
    this.isPlaying = true;
  }

  /** 清空队列并停止播放 */
  public clear() {
    this.queue = [];
    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;
  }

  public setMute(mute: boolean) {
    this.audio.muted = mute;

    if (mute) {
      this.clear();
    }
  }

  /** 判断当前是否在播放 */
  public get playing() {
    return this.isPlaying;
  }

  /** 获取当前队列长度 */
  public get size() {
    return this.queue.length;
  }
}
